import Api from '@/services/Api'

export default {
    getAll(search) {
        return Api().get('feedback', {
            params: {
                search: search
            }
        })
    },
    getList(page, limit) {
        return Api().get(`feedback/${page}`, {
            params: {
                limit: limit
            }
        })
    },
    getById(id) {
        return Api().post(`feedback/${id}`)
    },
    create(msg) {
        return Api().post('feedback', msg)
    },
    delete(id) {
        return Api().delete(`feedback/${id}`)
    }
}
